/**
 * Created by Ivan on 21.06.2026
 */

(function () {
    const original = MissionsTool.getMissionMenu;

    MissionsTool.getMissionMenu = function (mission) {
        const actions = original.call(this, mission);
        if (mission.type !== Mission.TYPE_LORYS_DERBY) {
            return actions;
        }

        actions.openStartWindow = displayToolWindow(() => new LorysDerbyStartWindow(mission));
        actions.openWindow = displayToolWindow(() => new LorysDerbyWindow(mission));
        actions.openFinishWindow = displayToolWindow(() => new LorysDerbyFinishWindow(mission));

        actions.completeStage = () => {
            const logic = mission.logic;
            const stage = logic.getCurrentStage();
            if (!stage) {
                return;
            }

            if (!logic.isUnlocked()) {
                logic.startCompetition();
            }

            const need = stage.goal - logic.level;
            if (need > 0) {
                logic.incLevel(need);
            }
        };

        actions.startExtraChallenge = () => {
            const logic = mission.logic;
            if (!logic.isUnlocked()) {
                logic.startCompetition();
            }

            logic.level = 0;
            logic.stage = logic.regularStagesCount;
            logic.update();
        };

        return actions;
    };
}());
